import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'cream' | 'sage' | 'white';
  id?: string;
}
export function Section({
  children,
  className = '',
  background = 'cream',
  id
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#FAF7F2]',
    sage: 'bg-[#F0F4EE]',
    white: 'bg-white'
  };
  return <section id={id} className={`py-10 md:py-24 px-4 sm:px-6 lg:px-8 ${bgColors[background]} ${className}`} data-id="element-117">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-118">
        {children}
      </motion.div>
    </section>;
}